import { render, staticRenderFns } from "./4b083a03-4ee5-4001-ba21-a5d385d3a3ea.vue?vue&type=template&id=32d8b77f&scoped=true"
import script from "./4b083a03-4ee5-4001-ba21-a5d385d3a3ea.vue?vue&type=script&lang=ts"
export * from "./4b083a03-4ee5-4001-ba21-a5d385d3a3ea.vue?vue&type=script&lang=ts"
import style0 from "./4b083a03-4ee5-4001-ba21-a5d385d3a3ea.vue?vue&type=style&index=0&id=32d8b77f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d8b77f",
  null
  
)

export default component.exports